module.exports = __webpack_public_path__ + "img/智障玩意.9c74db4e.png";